import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { Text, Paper, Container, Loader, Stack, Alert } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useState } from "react";
import { loginWithToken } from "../api";
import { useStore } from "../store";

// Redeems a one-time login token (e.g. an admin impersonation link) and signs the user in.
export default function LoginLink({ params }) {
  const [, setLocation] = useLocation();
  const initialized = useRef(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const setAuthToken = useStore((state) => state.setAuthToken);
  const saveCurrentSession = useStore((state) => state.saveCurrentSession);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    loginWithToken(params.token)
      .then((data) => {
        // Preserve the current (e.g. admin) session so it can be switched back to.
        saveCurrentSession();
        setAuthToken(data.access_token);
        setLocation("/home");
      })
      .catch((err) => {
        setErrorMessage(
          err?.cause === 400
            ? "This login link is invalid or has already been used."
            : "Login failed: " + (err?.message ?? err)
        );
      });
  }, [params.token, setAuthToken, saveCurrentSession, setLocation]);

  return (
    <Container size="sm" mt="xl">
      <Paper radius="md" p="xl" withBorder>
        {errorMessage ? (
          <Alert
            variant="light"
            color="red"
            title="Login Failed"
            icon={<IconInfoCircle />}
          >
            {errorMessage}
          </Alert>
        ) : (
          <Stack gap="sm" align="center">
            <Loader size="xl" />
            <Text>Logging you in...</Text>
          </Stack>
        )}
      </Paper>
    </Container>
  );
}
